import { render, staticRenderFns } from "./PersonalizationSettings.vue?vue&type=template&id=cb61fa5a"
import script from "./PersonalizationSettings.vue?vue&type=script&lang=js"
export * from "./PersonalizationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports